<template>
    <el-radio-group v-model="values" @input="$emit('input', values)" style="width: calc(100% - 50px);">
        <el-radio v-for="(radioitem, ridx) in formData.options" :key="ridx" :label="radioitem.label">
            {{ radioitem.label }}
        </el-radio>
    </el-radio-group>
</template>
<script>
export default {
    props: {
        formData: {
            type: Object
        },
        value: {
            type: [Number, String]
        }
    },
    watch: {
        value: {
            handler(val) {
                this.values = val;
            },
            immediate: true
        }
    },
    data() {
        return {
            values: this.value,
        }
    },
    methods: {
        getWidth() {
            if (this.formData.col == 24) return true;
            return false;
        }
    }
}
</script>
<style lang="scss" scoped></style>